"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _match = _interopRequireDefault(require("autosuggest-highlight/match"));

var _parse = _interopRequireDefault(require("autosuggest-highlight/parse"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    textField: {
      padding: spacing(6 / 8)
    }
  };
});

var Autocomplete = function Autocomplete(_ref2) {
  var options = _ref2.options,
      label = _ref2.label,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'outlined' : _ref2$variant,
      _ref2$highlight = _ref2.highlight,
      highlight = _ref2$highlight === void 0 ? false : _ref2$highlight,
      getOptionLabel = _ref2.getOptionLabel,
      muiAutocompleteProps = (0, _objectWithoutProperties2["default"])(_ref2, ["options", "label", "variant", "highlight", "getOptionLabel"]);
  var classes = useStyles();
  var renderHighlightedOption = (0, _react.useCallback)(function (_ref3, option) {
    var inputValue = _ref3.inputValue;
    var optionLabel = getOptionLabel(option);
    var matches = (0, _match["default"])(optionLabel, inputValue);
    var parts = (0, _parse["default"])(optionLabel, matches);
    return /*#__PURE__*/_react["default"].createElement("div", null, parts.map(function (part) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        key: part.text,
        style: {
          fontWeight: part.highlight ? 700 : 400
        }
      }, part.text);
    }));
  }, [getOptionLabel]);
  var renderOption = (0, _react.useCallback)(function (props, option) {
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, (0, _extends2["default"])({}, props, {
      key: option
    }), getOptionLabel(option));
  }, [getOptionLabel]);
  return /*#__PURE__*/_react["default"].createElement(_material.Autocomplete, (0, _extends2["default"])({}, muiAutocompleteProps, {
    options: options,
    getOptionLabel: getOptionLabel,
    onChange: muiAutocompleteProps.onChange,
    renderInput: function renderInput(props) {
      return /*#__PURE__*/_react["default"].createElement(_material.TextField, (0, _extends2["default"])({}, props, {
        variant: variant,
        label: label,
        inputProps: _objectSpread(_objectSpread({}, props.inputProps), {}, {
          className: classes.textField
        })
      }));
    },
    renderOption: highlight ? renderHighlightedOption : renderOption
  }));
};

Autocomplete.propTypes = {};
var _default = Autocomplete;
exports["default"] = _default;